import { useContext, useEffect, useState } from 'react';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { useFirestoreOrderBy } from '../../firebase/useFirestore';
import { db, timestamp } from '../../firebase/config';
import { v4 as uuid } from 'uuid';
import { client } from '../../hooks/Client';
import { SavedIcon } from '../../StateManagment/SavedIcon';
import { Auth } from '../../StateManagment/Auth';
import DragIndicatorOutlinedIcon from '@mui/icons-material/DragIndicatorOutlined';
import Table from '../common/table/Table.jsx';
import TableCell from '../common/table/TableCell.jsx';
import TableDragHandleCell from '../common/table/TableDragHandleCell.jsx';

const LocationsTable = () => {
    const [auth] = useContext(Auth);
    const [saved, setSaved] = useContext(SavedIcon);

    const [dragArrayData, setDragArrayData] = useState([]);

    const locations = useFirestoreOrderBy('Locations', 'Position', 'asc');

    useEffect(() => {
        setDragArrayData(locations);
    }, [locations]);

    const handleDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(dragArrayData);
        const [movedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, movedItem);

        setDragArrayData(items);

        items.forEach((item, idx) => {
            db.collection('Locations')
                .doc(item.docid)
                .update({ Position: idx + 1 });
        });

        setSaved('flex');
    };

    const titleHandler = (e) => {
        const docid = e.target.dataset.docid;
        const newTitle = e.target.value;

        db.collection('Locations')
            .doc(docid)
            .update({ Title: newTitle })
            .then(() => {
                setSaved('flex');
            });
    };

    const addLocation = () => {
        db.collection('Locations').add({
            ID: uuid(),
            Title: '',
            CompagnyID: client,
            Compagny: client,
            Position: locations.length + 1,
            Timestamp: timestamp,
            User: auth.ID
        });
    };

    const deleteLocation = (e) => {
        const docid = e.currentTarget.dataset.docid;

        db.collection('Locations')
            .doc(docid)
            .delete()
            .then(() => {
                setSaved('flex');
            });
    };

    const columns = [
        { key: 'drag', label: '', searchable: false },
        { key: 'title', label: 'TITEL' },
        { key: 'delete', label: 'VERWIJDEREN', searchable: false },
    ];

    return (
        <Table
            columns={columns}
            items={dragArrayData || []}
            getItemKey={(item) => item.ID}
            renderRow={(item) => (
                <>
                    <TableDragHandleCell>
                        <DragIndicatorOutlinedIcon />
                    </TableDragHandleCell>
                    <TableCell>
                        <input
                            type="text"
                            data-docid={item.docid}
                            defaultValue={item.Title}
                            onChange={titleHandler}
                        />
                    </TableCell>
                    <TableCell>
                        <DeleteOutlinedIcon
                            className="table-delete-icon"
                            data-docid={item.docid}
                            onClick={deleteLocation}
                        />
                    </TableCell>
                </>
            )}
            searchAccessor={(item) => item?.Title || ''}
            searchPlaceholder="Zoeken op locatie"
            emptyMessage="Nog geen locaties toegevoegd."
            draggable
            droppableId="locationsItems"
            onDragEnd={handleDragEnd}
            addRow={{
                toolTipContent: 'Locatie toevoegen',
                onClick: addLocation,
            }}
        />
    );
};

export default LocationsTable;
